import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { localStorageLimits } from './LocalStorageLimits';
var LocalStorageAdapter = /*#__PURE__*/_createClass(function LocalStorageAdapter() {
  var _this = this;
  var lsLimits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : localStorageLimits;
  var ls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.localStorage;
  _classCallCheck(this, LocalStorageAdapter);
  _defineProperty(this, "putData", function (tool_id, key, value) {
    _this.localStorageLimits.addToLimit(tool_id, key, value);
    _this.localStorage.setItem(_this.getKey(tool_id, key), value);
  });
  _defineProperty(this, "getKey", function (tool_id, key) {
    return "lti|platform_storage|".concat(tool_id, "|").concat(key);
  });
  _defineProperty(this, "getData", function (tool_id, key) {
    return _this.localStorage.getItem(_this.getKey(tool_id, key));
  });
  _defineProperty(this, "clearData", function (tool_id, key) {
    var value = _this.getData(tool_id, key);
    if (value) {
      _this.localStorageLimits.removeFromLimit(tool_id, key, value);
      _this.localStorage.removeItem(_this.getKey(tool_id, key));
    }
  });
  this.localStorageLimits = lsLimits;
  this.localStorage = ls;
});
export { LocalStorageAdapter as default };
export var localStorageAdapter = new LocalStorageAdapter();